// extracted by mini-css-extract-plugin
export default {"emptyMessageTitle":"styles_emptyMessageTitle__aprVj","emptyMessageSubtitle":"styles_emptyMessageSubtitle__T7pKZ","emptyMessageList":"styles_emptyMessageList__u2fBl"};